import {Injectable} from '@angular/core';
import {HttpService} from './http-service';
import {Observable, Observer} from 'rxjs/Rx';
import {
    TAction,
    TGeradorFlag,
    TGeradorView,
    TFinanceSide,
    TFinanceDate,
    TConsumoCalc,
    TGaleriaTipo,
} from "../app/enum";
import {Util} from "../app/util";

@Injectable()
export class HotspotService {

    constructor(public http: HttpService, public util: Util) { //public injector: Injector

    }

    hotspot(action: TAction, hotspotID: number = 0, profileID: number = 0, json: any = null, params: string = ''): Observable<any> {

        let url = 'SYNC-Hotspot?Action=' + TAction[action] + '&HotspotID=' + hotspotID + '&ProfileID=' + profileID + params;

        let dataJSon = 'JSon=' + JSON.stringify(json);

        return this.http.post(url, dataJSon);

    }

    chamada(action: TAction, profileID: number = 0, json: any = null): Observable<any> {

        let url = 'SYNC-Chamada?Action=' + TAction[action] + '&ProfileID=' + profileID;

        let dataJSon = 'JSon=' + JSON.stringify(json);

        return this.http.post(url, dataJSon);

    }

    setting(action: TAction, hotspotID: number = 0, json: any = null): Observable<any> {

        let url = 'SYNC-Setting?Action=' + TAction[action] + '&HotspotID=' + hotspotID;

        let dataJSon = 'JSon=' + JSON.stringify(json);

        return this.http.post(url, dataJSon);

    }

    unidade(action: TAction, brandedID: number = 0, hotspotID: number = 0, unidadeID: number = 0, json: any = null): Observable<any> {

        let url = 'SYNC-Unidade?Action=' + TAction[action] + '&BrandedID=' + brandedID + '&HotspotID=' + hotspotID + '&UnidadeID=' + unidadeID;

        let dataJSon = 'JSon=' + JSON.stringify(json);

        return this.http.post(url, dataJSon);

    }

    empresa(action: TAction, profileID: number = 0, hotspotID: number = 0, empresaID: number = 0, json: any = null): Observable<any> {

        let url = 'SYNC-Empresa?Action=' + TAction[action] + '&ProfileID=' + profileID + '&HotspotID=' + hotspotID + '&EmpresaID=' + empresaID;

        let dataJSon = 'JSon=' + JSON.stringify(json);

        return this.http.post(url, dataJSon);

    }

    recinto(action: TAction, profileID: number = 0, hotspotID: number = 0, recintoID: number = 0, json: any = null): Observable<any> {

        let url = 'SYNC-Recinto?Action=' + TAction[action] + '&ProfileID=' + profileID + '&HotspotID=' + hotspotID + '&RecintoID=' + recintoID;

        let dataJSon = 'JSon=' + JSON.stringify(json);

        return this.http.post(url, dataJSon);

    }

    contrato(action: TAction, contratoID: number = 0, profileID: number = 0, hotspotID: number = 0, contratoFlag: TGeradorFlag = TGeradorFlag.ctNenhum, json: any = null): Observable<any> {

        let url = 'SYNC-Contrato?Action=' + TAction[action] + '&ContratoID=' + contratoID + '&ProfileID=' + profileID + '&HotspotID=' + hotspotID + '&ContratoFlag=' + contratoFlag;

        let dataJSon = 'JSon=' + JSON.stringify(json);

        return this.http.post(url, dataJSon);

    }

    finance(action: TAction, paybookID: number, hotspotID: number = 0, filtredID: number, profileID: number = 0, paybookSide: TFinanceSide = TFinanceSide.cdTodos, cashday: string = '', financeDate: TFinanceDate = TFinanceDate.fdMes, consumoCalc: TConsumoCalc = TConsumoCalc.ccVenda, contratoView: TGeradorView = TGeradorView.cvGanhoMrr, json: any = null): Observable<any> {

        let url = 'SYNC-Finance?Action=' + TAction[action] + '&PaybookID=' + paybookID + '&HotspotID=' + hotspotID + '&FiltredID=' + filtredID + '&ProfileID=' + profileID + '&PaybookSide=' + paybookSide + '&Cashday=' + cashday + '&FinanceDate=' + financeDate + '&ConsumoCalc=' + consumoCalc + '&ContratoView=' + contratoView;

        let dataJSon = 'JSon=' + JSON.stringify(json);

        return this.http.post(url, dataJSon);

    }

    contaby(action: TAction, hotspotID: number = 0, filtredID: number, profileID: number = 0, paybookSide: TFinanceSide = TFinanceSide.cdTodos, cashday: string = '', financeDate: TFinanceDate = TFinanceDate.fdMes, json: any = null): Observable<any> {

        let url = 'SYNC-Contaby?Action=' + TAction[action] + '&HotspotID=' + hotspotID + '&FiltredID=' + filtredID + '&ProfileID=' + profileID + '&PaybookSide=' + paybookSide + '&Cashday=' + cashday + '&FinanceDate=' + financeDate;

        let dataJSon = 'JSon=' + JSON.stringify(json);

        return this.http.post(url, dataJSon);

    }

    paybook(action: TAction, paybookID: number, hotspotID: number = 0, geradorID: number = 0, profileID: number = 0, profileRnid: string = '', json: any = null, params: string = ''): Observable<any> {

        let url = 'SYNC-Paybook?Action=' + TAction[action] + '&PaybookID=' + paybookID + '&HotspotID=' + hotspotID + '&ContratID=' + geradorID + '&ProfileID=' + profileID + '&ProfileRnid=' + profileRnid + params;

        let dataJSon = 'JSon=' + JSON.stringify(json);

        return this.http.post(url, dataJSon);

    }

    consumo(action: TAction, paybookID: number, json: any = null): Observable<any> {

        let url = 'SYNC-Consumo?Action=' + TAction[action] + '&PaybookID=' + paybookID;

        let dataJSon = 'JSon=' + JSON.stringify(json);

        return this.http.post(url, dataJSon);

    }

    payment(action: TAction, gateweyID: number = 0, hotspotID: number = 0, paymentAuth: string = '', params: string = ''): Observable<any> {

        let url = 'SYNC-Payment?Action=' + TAction[action] + '&GateweyID=' + gateweyID + '&HotspotID=' + hotspotID + '&PaymentAuth=' + paymentAuth + params;

        return this.http.get(url, {});

    }

    conveny(action: TAction, gateweyID: number = 0, hotspotID: number = 0, params: string = ''): Observable<any> {

        let url = 'SYNC-Conveny?Action=' + TAction[action] + '&GateweyID=' + gateweyID + '&HotspotID=' + hotspotID + params;

        return this.http.get(url, {});

    }

    cashier(action: TAction, cashierID: number, hotspotID: number, profileID: number = 0, json: any = null): Observable<any> {

        let url = 'SYNC-Cashier?Action=' + TAction[action] + '&CashierID=' + cashierID + '&HotspotID=' + hotspotID + '&ProfileID=' + profileID;

        let dataJSon = 'JSon=' + JSON.stringify(json);

        return this.http.post(url, dataJSon);

    }

    usuario(action: TAction, hotspotID: number, profileID: number = 0, json: any = null): Observable<any> {

        let url = 'SYNC-Usuario?Action=' + TAction[action] + '&HotspotID=' + hotspotID + '&ProfileID=' + profileID;

        let dataJSon = 'JSon=' + JSON.stringify(json);

        return this.http.post(url, dataJSon);

    }

    integra(action: TAction, hotspotID: number, brandedID: number = 0, integraCode : string = '', json: any = null): Observable<any> {

        let url = 'SYNC-Integra?Action=' + TAction[action] + '&HotspotID=' + hotspotID + '&BrandedID=' + brandedID + '&IntegraCode=' + integraCode;

        let dataJSon = 'JSon=' + JSON.stringify(json);

        return this.http.post(url, dataJSon);

    }

    followe(action: TAction, hotspotID: number, profileID: number = 0, json: any = null): Observable<any> {

        let url = 'SYNC-Followe?Action=' + TAction[action] + '&HotspotID=' + hotspotID + '&ProfileID=' + profileID;

        if (json) {
            let dataJSon = 'JSon=' + JSON.stringify(json);
            return this.http.post(url, dataJSon);
        }

        return this.http.get(url, {});

    }

    galeria(action: TAction, hotspotID: number, galeriaID: number = 0, galeriaTipo: TGaleriaTipo = TGaleriaTipo.gtNenhum, json: any = null, params: string = ''): Observable<any> {

        let url = 'SYNC-Galeria?Action=' + TAction[action] + '&HotspotID=' + hotspotID + '&GaleriaID=' + galeriaID + '&GaleriaTipo=' + galeriaTipo + params;

        let dataJSon = 'JSon=' + JSON.stringify(json);

        return this.http.post(url, dataJSon);

    }

    horario(action: TAction, horarioID: number): Observable<any> {

        let url = 'SYNC-Horario?Action=' + TAction[action] + '&HorarioID=' + horarioID;

        return this.http.get(url, {});

    }

    youtubeInfo(videoID: string): Observable<any> {

        return Observable.create(observer => {

            let url = 'https://youtube.com/get_video_info?video_id=' + videoID;
            this.http.get(url, {}, true).subscribe(
                data => {

                    // se ão der certo, tentar getBase64Image (se estiver bugada, usar a do Agilezz)
                    this.youtubeImage(videoID, observer, data);

                }, erro => {
                    observer.error(erro);
                    return Observable.throw('Erro para acessar miniatura do YouTube.');
                });

        });

    }

    youtubeImage(videoID: string, observer: Observer<any>, dataPrev: any) {

        let url = 'http://i1.ytimg.com/vi/' + videoID + '/hqdefault.jpg';

        return this.http.get(url, {}, true)
            .subscribe(data => {

                data = this.util.base64.encode(data);

                observer.next({api: dataPrev, image: data});

            }, erro => {
                observer.error(erro);
                return Observable.throw('Erro para codificar miniatura do YouTube.');
            });

    }

}



// WEBPACK FOOTER //
// ./src/providers/hotspot-service.ts